<script>
import { getGroupProductName } from '@/api/business/containerOrder'
import { getGroupProductName as getDomesticGroupProductNameAPI } from '@/api/business/containerDomesticOrder'

export default {
  name: 'ProductNameGroupInput',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    //查询 默认0: 外贸，1: 内贸
    searchType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      productList: [],
      localValue: this.value,
      loading: false,
      // 存储所有定时器
      timers: []
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    },
    localValue(newValue) {
      this.$emit('input', newValue)
      this.$emit('change', newValue)
    }
  },
  mounted() {
    this.loadData();
  },
  beforeDestroy() {
    // 清理所有定时器，防止内存泄漏
    this.timers.forEach(timer => {
      clearInterval(timer)
    })
    this.timers = []
  },
  methods: {
    loadData() {
      this.loading = true;

      // 根据 searchType 决定调用哪个 API
      const reqPromise = this.searchType == 0 ? getGroupProductName() : getDomesticGroupProductNameAPI()
      // 获取分组的品名数据
      reqPromise.then(res => {
        this.productList = res.data || []
      }).catch(err => {
        console.error('获取品名数据失败:', err)
        // this.productList = []
      }).finally(() => {
        this.loading = false;
      })

      // // 模拟100条数据用于测试
      // setTimeout(() => {
      //   const mockData = []
      //   const productTypes = ['钢材', '木材', '塑料', '化工原料', '电子产品', '机械设备', '纺织品', '食品', '建材', '金属制品']
      //   const specifications = ['A级', 'B级', 'C级', '标准', '优质', '特级', '普通', '精品', '高端', '经济型']
      //   const units = ['吨', '件', '箱', '包', '米', '公斤', '套', '个', '批', '车']

      //   for (let i = 1; i <= 100; i++) {
      //     const productType = productTypes[Math.floor(Math.random() * productTypes.length)]
      //     const specification = specifications[Math.floor(Math.random() * specifications.length)]
      //     const unit = units[Math.floor(Math.random() * units.length)]
      //     const number = String(i).padStart(3, '0')

      //     mockData.push({
      //       id: i,
      //       productName: `${productType}${specification}${number}号-${unit}装`,
      //       category: productType,
      //       specification: specification
      //     })
      //   }

      //   // 使用模拟数据（开发测试用）
      //   this.productList = mockData
      //   this.loading = false;
      // }, 3000)
      // // 模拟网络延迟
    },
    querySearch(queryString, cb) {
      if (this.loading) {
        const checkLock = setInterval(() => {
          if (!this.loading) {
            clearInterval(checkLock)
            // 从定时器数组中移除
            const index = this.timers.indexOf(checkLock)
            if (index > -1) {
              this.timers.splice(index, 1)
            }
            this.filterResult(queryString, cb)
          }
        }, 100)
        // 将定时器添加到数组中管理
        this.timers.push(checkLock)
        return
      }
      this.filterResult(queryString, cb)
    },
    filterResult(queryString, cb) {
      let results;
      if (queryString) {
        // 有输入内容时，搜索全部数据
        results = this.productList.filter(this.createFilter(queryString));
      } else {
        // 没有输入内容时，只显示前50条
        results = this.productList.slice(0, 50);
      }
      cb(results);
    },
    createFilter(queryString) {
      return (product) => {
        if (!product || !product.productName) {
          return false;
        }
        // 支持包含匹配，而不只是开头匹配
        return product.productName.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    handleSelect(item) {
      if (item && item.productName) {
        this.localValue = item.productName
      }
    }
  }
}
</script>
<template>
  <el-autocomplete
    v-model='localValue'
    :fetch-suggestions='querySearch'
    :placeholder='placeholder'
    :disabled='disabled'
    :clearable='clearable'
    @select='handleSelect'
    value-key="productName"
  >
  </el-autocomplete>
</template>

<style scoped lang="scss">
.el-autocomplete {
  width: 100%;
}
</style>


